<div class="delivery-accelerators-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="accelerators()"></grid-content>
</div>